<template>
  <div class="ma-0 pa-0 mt-n10">
    <v-container>
      <div>
        <v-row>
          <v-col cols="8">
            <v-row>
              <CRUDList class="mt-10" :canAdd="false"
              :canEdit="false" :canSave="false"
              :enableFixedHeaders="true" :displayTopPagination="false"
              :headers="headers" :baseCrudKey="baseCrudKeyForDTable"
              tableWrapperDynamicClassname='elevation-3 ma-3 pt-0 pa-1 taxroll-table-wrapper'
              tableDynamicClassname='taxroll-custom-table' tableDynamicHeight='300'
              :headersWithColsSpan="headersWithColsSpan" :defaultSortBy="defaultSortBy"
              :loadingData="gridLoading.flag"
              :loadingText="gridLoading.text"
              @loadCRUDList = "loadAssesorDataHandlder">
            </CRUDList>
            <v-col cols="6" class="ma-0 pt-0 pb-0 mt-n3">
              <p class="">Preview Tax Record</p>
            </v-col>
            <v-col cols="3" class="ma-0 pa-0 mt-n7">
              <v-checkbox label="Show Errors Only" class="input-text-size"
              @change="loadAssesorDataHandlder" v-model="criteriaState.showErrorsOnly" />
            </v-col>
            <v-col cols="3" class="ma-0 pa-0 mt-n7">
              <v-checkbox label="Show SA Only" class="input-text-size"
              @change="loadAssesorDataHandlder" v-model="criteriaState.showSAOnly" />
            </v-col>
            <v-col cols="4" class="ma-0 pt-0 pb-0 mt-n2">
              <v-textarea class="input-text-size pa-0  mt-n1 dec-line-height" outlined rows="9"
              label="Owner Info Consolidated View" :value="handleConsolidateView()" readonly />
            </v-col>
            <v-col cols="4" class="ma-0 pt-0 pb-0 mt-n2">
              <p class="input-text-size mb-n1">Parcel Id: {{ formatToPidWithDashes() }}</p>
              <p class="input-text-size mb-n1 pt-1">
                Situs Address: {{ getItemItem.situsAddress }}</p>
              <v-textarea class="input-text-size pt-2 dec-line-height"
               v-model="getItemItem.legalDesc" outlined rows="4"
               label="Legal Description" readonly />
            </v-col>
            <v-col cols="4" class="ma-0 pt-0 pb-0 mt-n2">
              <p class="input-text-size mb-n1">Land Value: {{ getItemItem.land || null }}</p>
              <p class="input-text-size mb-n1 pt-1">Improvement Value:
                {{ getItemItem.improvements || null }}</p>
              <p class="input-text-size mb-n1 pt-1">Mobile Home Value:
                {{ getItemItem.mobileHome || null }}</p>
              <p class="input-text-size mb-n1 pt-1">Penalty Value: {{ getItemItem.assessorPenalty
              || null }}</p>
              <p class="input-text-size mb-n1 pt-1">Exemptions:
                 {{ getItemItem.exemptions || null }}</p>
            </v-col>
            <!-- Support Notes: what makes THIS county's roll different (fire taxes,
            conservancy/SA districts, new TIF districts). The roll is run once a year, so the
            reminders are kept on the county's taxConfig and outlive the tax year and the
            import. Everyone who can open this screen reads them; only a TM admin can change
            them, and a county with no notes yet sees nothing rather than an empty panel. -->
            <v-col cols="12" class="ma-0 pt-0 pb-0 mt-n2" v-if="showSupportNotes">
              <v-textarea class="input-text-size dec-line-height" outlined rows="4" auto-grow
                label="Support Notes" v-model="supportNotes" :readonly="!isTmAdmin"
                :hint="supportNotesHint" persistent-hint
                @input="supportNotesTouched = true" />
              <v-btn v-if="isTmAdmin" small text color="blue darken-1"
                class="mt-1 support-notes-save"
                :loading="supportNotesSaving" :disabled="supportNotesSaving"
                @click="saveSupportNotes">
                Save Notes
              </v-btn>
            </v-col>
          </v-row>
          </v-col>
          <v-col cols="4">
            <p class="input-text-size mt-8 mb-n1">New Tax Year: {{ newTaxYear }}</p>
            <!-- Chosen first, because it is what decides which import profiles are offered
            below. Preselected from the county's Tax setting - a county does not change assessor
            vendor from one year to the next - but still editable, since the setting is new and
            most counties have not filled it in yet. -->
            <v-select
              v-model="selectedAssessorCompany"
              :items="assessorCompanies"
              label="Assessor Company"
              dense
              outlined
              class="input-text-size mt-2 assessor-company-select"
              hide-details
            />
            <!-- Only for counties whose files come off the Landmark FTP. Tulsa converts from
            an uploaded CSV and has no folder there, so the control and its listing call are
            both skipped rather than failing in front of the clerk every page load. -->
            <v-row no-gutters align="center" v-if="landmarkFtpApplies">
              <v-col cols="9">
                <v-select
                  v-model="selectedLandmarkFile"
                  :items="landmarkFtpFiles"
                  item-text="label"
                  item-value="name"
                  label="Select Landmark FTP File"
                  :loading="landmarkFtpLoading"
                  :no-data-text="landmarkNoDataText"
                  clearable
                  dense
                  outlined
                  class="input-text-size mt-2"
                  hide-details
                />
              </v-col>
              <v-col cols="3" class="text-center">
                <v-btn class="input-text-size mt-2" text color="blue darken-1"
                  :loading="unzipLoading" :disabled="unzipLoading || rollInProgress"
                  @click="unzipFtpFile">
                  Unzip
                </v-btn>
              </v-col>
            </v-row>
            <UploadToBackend ref="uploadToBackend"
            profileName="Select Assesor Profile" :folderName="folderName"
            :profileItem="assesorListItem" :profileDisabled="!selectedAssessorCompany"
            profileDisabledText="Choose an Assessor Company first"
            @loadCRUDList="fromUploadToBackend"
            @importStarted="onImportStarted" />
            <v-row align="center">
              <v-col cols="6">
                <h3 class="input-text-size mb-n4">Total Records in File</h3>
              </v-col>
              <v-col cols="6">
                <v-text-field hide-details rows="1" label=""
                v-model="assesorTotalData.totalRecords"
                readonly class="input-text-size py-0 my-0 import-and-balance-total-records" />
              </v-col>
            </v-row>
            <v-row align="center" class="my-0">
              <v-col cols="6">
                <h3 class="input-text-size mb-n4">Total Tax Amount</h3>
              </v-col>
              <v-col cols="6">
                <v-text-field hide-details rows="1" label=""
                 :value="getTotalTaxAmount()"
                readonly class="input-text-size py-0 my-0" />
              </v-col>
            </v-row>
            <v-row align="center" class="my-n2">
              <v-col cols="6">
                <h3 class="input-text-size mb-n4">Records with Errors</h3>
              </v-col>
              <v-col cols="6">
                <v-text-field hide-details rows="1" label=""
                v-model="assesorTotalData.totalRecordsWithError"
                readonly class="input-text-size py-0 my-0" />
              </v-col>
            </v-row>
            <!-- Tulsa only: the Assessor file carries the subdivision NAME, so the conversion
            keeps the shared Additions list up to date from it. Hidden for counties whose file
            sends only the code - nothing is synced for them. -->
            <v-row align="center" class="my-n2" v-if="additionSync">
              <v-col cols="6">
                <h3 class="input-text-size mb-n4">Additions Created / Updated</h3>
              </v-col>
              <v-col cols="6">
                <!-- this readonly field is only ~174px wide, so it holds just the two numbers;
                the sentence underneath has the full width to spell them out -->
                <v-text-field hide-details rows="1" label=""
                :value="additionSyncCounts"
                readonly class="input-text-size py-0 my-0" />
              </v-col>
            </v-row>
            <v-row v-if="additionSync" class="my-n2">
              <v-col cols="12">
                <p class="input-text-size mb-1">
                  Shared Additions list updated from the Assessor file:
                  {{ additionSyncDetail }}
                </p>
              </v-col>
            </v-row>
            <v-row v-if="additionSyncChangedCodes" class="my-n2">
              <v-col cols="12">
                <p class="input-text-size mb-1">
                  Descriptions taken from the Assessor file for:
                  {{ additionSyncChangedCodes }}
                </p>
              </v-col>
            </v-row>
            <v-row v-if="additionSyncConflictCodes" class="my-n2">
              <v-col cols="12">
                <p class="input-text-size mb-1 red--text">
                  Sent under more than one subdivision name - longest kept, please review:
                  {{ additionSyncConflictCodes }}
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-btn small text color="blue darken-1" @click="printErrorsList">
                  Print Error List
                </v-btn>
                <v-btn small text color="blue darken-1" @click="printAdvancedTax">
                  Print Advanced Tax
                </v-btn>
                <v-btn small text color="blue darken-1" class="print-abstract-btn"
                  @click="printAbstract">
                  Print Abstract
                </v-btn>
                <v-checkbox label="Original Tax Districts" class="input-text-size mt-n1"
                 v-model="showOriginalTaxDistrictsFlag" />
              </v-col>
              <!-- A roll can run for a while on a big county and the only feedback used to be
              the flash at the very end, so each button spins while its own roll runs and all
              three stay disabled until it finishes - nothing is started on top of a roll.
              A roll that has finished says so and stays said: Murray's 2026 roll went live with
              ~300 records missing their mortgage codes because nothing on this screen showed
              that Roll Mortgage Codes had never been run, and a skipped roll looks exactly like
              a done one. The marks belong to the roll staged NOW - a new import brings all
              three buttons back (see rollStatus). -->
              <v-col cols="6">
                <!-- The button on its own line and the mark under it, rather than one wrapping
                row: the marks are not all the same length, and left to wrap the tick landed
                beside one button and below the next. -->
                <div v-for="roll in assessorRolls" :key="roll.key" class="assessor-roll-row mb-1">
                  <v-btn small text color="blue darken-1" :loading="rollRunning === roll.key"
                   :disabled="rollInProgress || isRollDone(roll.key)"
                   :class="`roll-btn-${roll.key}`" @click="runRoll(roll)">
                    {{ roll.label }}
                  </v-btn>
                  <!-- not a flex row: the mark is long enough to wrap in this column, and as a
                  flex item the tick was pushed onto a line of its own -->
                  <div v-if="isRollDone(roll.key)" class="ml-3 mt-n1 input-text-size">
                    <!-- the SVG path, not the name: this app's Vuetify runs iconfont 'mdiSvg',
                    where a string icon name renders as nothing at all -->
                    <v-icon small color="green darken-2" class="mr-1">{{ icons.mdiCheck }}</v-icon>
                    <span class="input-text-size green--text text--darken-2"
                      :class="`roll-done-${roll.key}`">{{ rolledText(roll.key) }}</span>
                    <!-- Staging can be edited after a roll (a corrected mortgage code, a status
                    code added by hand), and then the roll has to be re-runnable without
                    re-importing the file. Kept to TM Admin because re-running Roll Comments
                    wipes and rebuilds the rolled-comments table. -->
                    <v-btn v-if="isTmAdmin" x-small text color="blue darken-1" class="ml-1"
                     :disabled="rollInProgress" :class="`roll-again-${roll.key}`"
                     @click="runRoll(roll)">
                      Run again
                    </v-btn>
                  </div>
                </div>
                <p v-if="rollInProgress" class="input-text-size mb-0 mt-1 blue--text text--darken-1">
                  {{ rollProgressText }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <template>
        </template>
        <!-- A conversion prints the abstract more than once and the copies are not the same
        report: Kay prints one off the assessor's roll, imports the Duck Creek special
        assessments, and prints another. Until they were named, both printed and both saved as
        "Abstract" with nothing on the page or in the file name to tell them apart. Prefilled
        with the default, so the ordinary case is still Print Abstract then Enter. -->
        <v-dialog v-model="abstractNameDialog" max-width="420" persistent>
          <v-card>
            <v-card-title class="input-text-size">Print Abstract</v-card-title>
            <v-card-text class="pb-0">
              <v-text-field v-model="abstractName" label="Report Name" autofocus
                class="input-text-size abstract-name-field" :rules="[abstractNameRule]"
                @keyup.enter="confirmPrintAbstract" />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn text color="blue darken-1" class="abstract-name-cancel"
                @click="abstractNameDialog = false">
                Cancel
              </v-btn>
              <v-btn text color="blue darken-1" class="abstract-name-ok"
                :disabled="!abstractNameValid" @click="confirmPrintAbstract">
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-container>
  </div>
</template>
<script>

import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import { mdiCheck } from '@mdi/js';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import { newTaxRollHeaders, newTaxRollMainHeaders } from '../../../shared/Utils/taxHeaders.utils';
import UploadToBackend from '../../../common/import/NewTaxRollUploadToBackend.vue';
import { commonFuncForFilterMtgCoProc, makeCriteriaStateNullIfEmptyString } from '../../common-utils/CommonTaxFunctionalities';
import { ASSESSOR_COMPANIES, profilesForCompany, usesLandmarkFtp } from './SpecialTaxItems.utils';
import { taxConfigScope } from '../../../../util/shared/system-config-scopes';
import { isAuthorised } from '../../../../store/auth/token';
import { authRoles } from '../../../../router/roleGroups';
import {
  amountFormat, defaultGridLoading, manageGridLoading, pIdFormat, zipFormat,
} from '../../../../util/shared/vue-global';
import { folderNameForUploadToBackend, getTaxYearStatus } from '../../common-utils/tax-common.util';
import { generateQueryString } from '../../../common/base/report/report-util';
import { clients } from '../../../../util/clients';
import {
  ftpEmptyMessage,
  ftpErrorMessage,
  readFtpFileList,
  readFtpMessage,
  readFtpPath,
} from '../../../../util/shared/ftp-file-list';
import '../../../../assets/style.css';

const { backendRest } = clients.direct;
// The backend returns this instead of 200/201 when another roll already holds the lock -
// a different situation from a roll that ran and failed, so it gets its own message.
const ROLL_ALREADY_RUNNING_STATUS = 409;
const ROLL_ALREADY_RUNNING_MESSAGE = 'Another roll is already running - please wait for it to finish.';
/* What the Print Abstract dialog offers. The same string the backend falls back to when no name
   is sent (abstractSummary.js), so pressing OK on the untouched box prints and files exactly
   what Print Abstract printed and filed before there was a dialog. */
export const DEFAULT_ABSTRACT_NAME = 'Abstract';
/* The three "roll to next year" steps, in the order they appear on screen. `key` is the backend's
   own roll key (assessorRollStatus.util.js) - it is what the saved "this has been run" record is
   stored and read back under, not display text. */
export const ASSESSOR_ROLLS = [
  {
    key: 'comments',
    label: 'Roll Comments',
    action: 'accessorRollTheComments',
    progress: 'Rolling comments... please wait.',
    success: 'Comments rolled successfully.',
    error: 'There was a problem rolling the comments.',
  },
  {
    key: 'mtgCodes',
    label: 'Roll Mortgage Codes',
    action: 'accessorRollTheMtgCode',
    progress: 'Rolling mortgage codes... please wait.',
    success: 'Mortgage codes rolled successfully.',
    error: 'There was a problem rolling the mortgage codes.',
  },
  {
    key: 'statusCodes',
    label: 'Roll Status Codes',
    action: 'accessorRollTheStatusCode',
    progress: 'Rolling status codes... please wait.',
    success: 'Status codes rolled successfully.',
    error: 'There was a problem rolling the status codes.',
  },
];
/* "10/29 2:15 PM" - the month and day are enough, because the mark only ever describes the roll
   staged now and that is this year's conversion. Shown in the browser's own timezone, which is
   the county's. */
const rolledAtText = (iso) => {
  const when = new Date(iso);
  if (Number.isNaN(when.getTime())) return '';
  const date = `${when.getMonth() + 1}/${when.getDate()}`;
  const time = when.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  return `${date} ${time}`;
};
export default {
  name: 'ImportAndBalance',
  data() {
    return {
      icons: { mdiCheck },
      baseCrudKey: 'assesorList',
      baseCrudKeyForDTable: 'assesorList-data',
      baseCrudKeyForTotal: 'baseCrudKeyForTotal',
      selProfileName: '',
      headers: newTaxRollHeaders,
      uploadFileNameUI: undefined,
      canUpload: true,
      headersWithColsSpan: newTaxRollMainHeaders,
      assessorCompanies: ASSESSOR_COMPANIES,
      selectedAssessorCompany: null,
      gridLoading: defaultGridLoading(),
      newTaxYear: null,
      folderName: folderNameForUploadToBackend.newTaxRoll,
      showOriginalTaxDistrictsFlag: false,
      landmarkFtpFiles: [],
      selectedLandmarkFile: null,
      landmarkFtpLoading: false,
      // Why the Landmark list is empty, shown inside the dropdown (ftp-file-list.js).
      landmarkFtpMessage: '',
      landmarkFtpLoaded: false,
      /* Whether the county's Assessor Company is known yet. The Landmark FTP box is
         decided by it, and the setting arrives with the taxConfig that created() loads -
         so the listing waits for that rather than firing at a county (Tulsa) whose
         answer is "do not ask". */
      taxConfigLoaded: false,
      unzipLoading: false,
      /* Plain text, line breaks and all, so the notes can be kept as a bulleted list. Filled
         from the county's taxConfig once it arrives (see the watcher) - and only while nobody
         has typed in the box, so a slow config load never overwrites an admin mid-sentence. */
      supportNotes: '',
      supportNotesTouched: false,
      supportNotesSaving: false,
      supportNotesHint: 'Internal reminders about this county\'s roll - editable by TM Admins only.',
      // null | 'comments' | 'mtgCodes' | 'statusCodes' - which roll is running right now. One
      // field rather than three flags, because only one roll may run at a time anyway.
      rollRunning: null,
      /* Which rolls the backend says have been run for the roll staged NOW, keyed by roll key -
         a null member is one that has not. Never assumed: it is read from the server on mount
         and after every roll and every import, so it survives a reload and is the same for the
         next user to open the screen. Cleared the moment an import starts, since from then on
         whatever was rolled describes a file that is being replaced. */
      rollStatus: { comments: null, mtgCodes: null, statusCodes: null },
      // What this abstract is to be called, asked for every time Print Abstract is pressed.
      abstractNameDialog: false,
      abstractName: DEFAULT_ABSTRACT_NAME,
    };
  },
  created() {
    /* No loadLandmarkFtpFiles() here: the listing is driven by the Assessor Company,
       which this config call is what supplies. The flag flips either way - a config
       that failed to load must leave the screen behaving as it did before, not sitting
       on a box that never appears. */
    this.loadConfig({ requiredScope: 'taxConfig' })
      .catch(() => {})
      .finally(() => { this.taxConfigLoaded = true; });
    this.loadAssessorFireTaxXRefRecords({
      baseCrudKey: 'assessorFireTaxXRefDropDown',
      criteria: {
        sortBy: [{ column: 'fireDistrict', direction: 'desc' }],
      },
    });
    this.loadAssesorTaxTotalHandler();
    this.loadRollStatus();
  },
  components: {
    CRUDList,
    UploadToBackend,
  },
  computed: {
    ...mapGetters('base/crud', [
      'items',
      'item',
      'criteria',
    ]),
    ...mapState({
      assesorTotalData: (state) => state.tax.newTaxroll.assesorTotalData,
      latestTaxYear: (state) => state.tax.taxCommon.latestTaxYear,
      taxSettingItem: (state) => state.SystemConfig.taxSettingItem,
    }),
    // Empty until a company is chosen, which is what leaves the profile dropdown disabled.
    assesorListItem() {
      return profilesForCompany(this.selectedAssessorCompany);
    },
    // The same TM admin check the comment list uses - Tax Admin is deliberately not enough.
    isTmAdmin() {
      return isAuthorised(authRoles.SuperAdmin);
    },
    /* A county user only gets the box once there is something in it to read; a TM admin always
       gets it, since they are the one who has to put the first note in. */
    showSupportNotes() {
      return this.isTmAdmin || !!(this.supportNotes || '').trim();
    },
    /* Shown only once the county's company is known and only for the companies that
       deliver through the Landmark FTP. A company nobody has set stays on the Landmark
       side, so a county that never filled the setting in keeps the box it has always
       had - see usesLandmarkFtp. */
    landmarkFtpApplies() {
      return this.taxConfigLoaded && usesLandmarkFtp(this.selectedAssessorCompany);
    },
    landmarkNoDataText() {
      if (this.landmarkFtpLoading) return 'Reading the Landmark FTP server...';
      return this.landmarkFtpMessage || 'No Landmark FTP files';
    },
    defaultSortBy() {
      return [
        {
          column: 'taxId',
          direction: 'desc',
        },
      ];
    },
    // Null until a conversion whose file names its subdivisions has run.
    additionSync() {
      return (this.assesorTotalData || {}).additionSync || null;
    },
    // Kept to two numbers so it never overflows the narrow readonly field.
    additionSyncCounts() {
      const sync = this.additionSync;
      if (!sync) return '';
      return `${sync.createdCount || 0} / ${sync.updatedCount || 0}`;
    },
    additionSyncDetail() {
      const sync = this.additionSync;
      if (!sync) return '';
      return `${sync.createdCount || 0} created, ${sync.updatedCount || 0} updated,`
        + ` ${sync.unchangedCount || 0} already correct.`;
    },
    // The counts are always exact; the code lists can be capped, so say when they are.
    additionSyncChangedCodes() {
      const sync = this.additionSync;
      if (!sync || !sync.updatedCount) return '';
      return this.formatAdditionCodeList(sync.updated, sync.updatedCount);
    },
    additionSyncConflictCodes() {
      const sync = this.additionSync;
      if (!sync || !sync.conflictCount) return '';
      return this.formatAdditionCodeList(sync.conflicts, sync.conflictCount);
    },
    assessorRolls() {
      return ASSESSOR_ROLLS;
    },
    /* The name is what the printed title and the saved file are both built out of, so a blank
       one has nothing to offer either. Trimmed, because a box holding only spaces is blank. */
    abstractNameValid() {
      return !!(this.abstractName || '').trim();
    },
    // One roll at a time: Roll Comments clears the rolled-comments table before it starts
    // writing, so a second run started on top of the first loses rows.
    rollInProgress() {
      return !!this.rollRunning;
    },
    rollProgressText() {
      const running = ASSESSOR_ROLLS.find((roll) => roll.key === this.rollRunning);
      return running ? running.progress : '';
    },
    getData() {
      return this.items('transform-mapper-list');
    },
    getItemItem() {
      return this.item(this.baseCrudKeyForDTable);
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKeyForDTable);
      },
      set(value) {
        this.setCriteria([this.baseCrudKeyForDTable, value]);
      },
    },
  },
  methods: {
    manageGridLoading,
    ...mapMutations('tax/MortgageCoProcessing', [
      'setPipeline',
    ]),
    ...mapActions(['reAuth', 'flashSuccess', 'flashError', 'flashInfo']),
    ...mapActions('SystemConfig', ['loadConfig', 'upsertConfigSpecificFields']),
    ...mapMutations('SystemConfig', ['setAfterUpdate']),
    ...mapMutations('base/crud', ['setCriteria', 'setItem', 'setItems']),
    /* Blanked the moment an import starts and refilled only by fromUploadToBackend, which the
       child emits once the backend has reported the run complete. A run that fails never gets
       there, so the fields stay blank rather than showing the previous run's totals as though
       they described the file just imported. */
    ...mapMutations('tax/newTaxroll', ['clearAssesorTotal']),
    ...mapActions('tax/newTaxroll', ['loadAssesorTax', 'loadAssesorTaxTotal', 'accessorRollTheComments', 'accessorRollTheMtgCode',
      'accessorRollTheStatusCode', 'loadAssessorFireTaxXRefRecords', 'loadAssessorRollStatus',
    ]),
    /* Saves the notes and nothing else: a specific-fields update writes the one key, so the
       rest of the county's taxConfig cannot be overwritten with whatever this screen happens
       to be holding. The server refuses the change for a non-admin, so the success message
       waits on the action reporting that the write actually went through. */
    async saveSupportNotes() {
      this.supportNotesSaving = true;
      try {
        const saved = await this.upsertConfigSpecificFields({
          calledScope: taxConfigScope.scope,
          item: taxConfigScope.buildSpecificItem(this.taxSettingItem.id, {
            [taxConfigScope.specificFields.newTaxRollNotes]: this.supportNotes,
          }),
        });
        if (!saved) return;
        /* Keep the loaded config in step with what was just written, so the Tax settings tab
           (and a second visit to this screen) does not send the pre-save text back. */
        this.setAfterUpdate({
          data: { ...this.taxSettingItem, newTaxRollNotes: this.supportNotes },
          scope: taxConfigScope.scope,
          newRecordID: null,
        });
        this.supportNotesTouched = false;
        this.flashSuccess('Notes saved.');
      } finally {
        this.supportNotesSaving = false;
      }
    },
    async loadLandmarkFtpFiles() {
      this.landmarkFtpLoading = true;
      this.landmarkFtpMessage = '';
      try {
        await this.reAuth();
        const { data } = await backendRest.get('/landmark/ftp/files');
        this.landmarkFtpFiles = readFtpFileList(data);
        if (!this.landmarkFtpFiles.length) {
          /* The server's own account of an empty result ("No Landmark folder for this
             county") when it gave one, which is a 200 and not a failure - so it goes in
             the dropdown and nowhere near flashError. */
          this.landmarkFtpMessage = readFtpMessage(data) || ftpEmptyMessage(readFtpPath(data));
        }
      } catch (e) {
        // The reason the FTP server gave, not "failed to load" - see TKT-000856.
        this.landmarkFtpFiles = [];
        this.landmarkFtpMessage = ftpErrorMessage(e);
        this.flashError(this.landmarkFtpMessage);
      } finally {
        this.landmarkFtpLoading = false;
      }
    },
    /* Pulls the selected archive off the Landmark FTP and expands it on the backend,
       flat and archive-prefixed, straight into this screen's own upload folder
       (targetFolder) - so the extracted files land in the same list as anything
       uploaded through the file input and import/delete out of one directory.
       Downloading and unzipping a full taxroll takes a while, so the button spins and
       stays disabled until the Uploaded files list underneath has been refreshed -
       that refresh is the point of the whole operation, so it is awaited here rather
       than left to the child to notice. */
    async unzipFtpFile() {
      if (!this.selectedLandmarkFile) {
        this.flashInfo('Please select a Landmark FTP file to unzip.');
        return;
      }
      this.unzipLoading = true;
      try {
        await this.reAuth();
        await backendRest.get('/landmark/ftp/extractfiles', {
          params: { fileName: this.selectedLandmarkFile, targetFolder: this.folderName },
        });
        await this.$refs.uploadToBackend.getFileListMethod();
        this.flashSuccess('Successfully unzipped FTP files.');
      } catch (e) {
        this.flashError('Failed to unzip Landmark FTP files.');
      } finally {
        this.unzipLoading = false;
      }
    },
    onAccessorDropDownChange(val) {
      const itemData = this.items('transform-mapper-list');
      const selProName = (this.assesorListItem || []).filter((dt) => dt.value === val);
      this.selProfileName = selProName.length ? selProName[0].name : '';
      const { filteredTaxItemData } = commonFuncForFilterMtgCoProc(itemData, 'Assessor File');
      const [filtTaxData] = filteredTaxItemData.filter((ft) => ft.name === val);
      this.setPipeline(filtTaxData || {});
    },
    fromUploadToBackend() {
      this.loadAssesorDataHandlder();
      this.loadAssesorTaxTotalHandler();
      // The staged roll has just been replaced, so the server's own answer about which rolls
      // have been run for it is the one that counts - this is what re-arms all three buttons.
      this.loadRollStatus();
    },
    loadAssesorDataHandlder() {
      manageGridLoading(this, true, 'Searching...');
      const returnCriteria = makeCriteriaStateNullIfEmptyString(this.criteriaState);
      this.criteriaState = { ...returnCriteria };
      const criteria = {
        ...this.criteriaState,
      };
      this.loadAssesorTax({
        criteria,
        baseCrudKey: this.baseCrudKeyForDTable,
        postProcessTrans: this.protestTaxPostProcessTrans,
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    loadAssesorTaxTotalHandler() {
      this.loadAssesorTaxTotal({
        baseCrudKey: this.baseCrudKeyForTotal,
      });
      const { currentTax } = getTaxYearStatus();
      this.newTaxYear = currentTax || (this.latestTaxYear + 1) || null;
    },
    // amountFormat turns a blank into '0.00', which is exactly the reading to avoid while an
    // import is staging - no figure yet is not the same as a roll that totals zero.
    getTotalTaxAmount() {
      const { totalTaxAmount } = this.assesorTotalData;
      if (totalTaxAmount === null || totalTaxAmount === undefined || totalTaxAmount === '') return '';
      return amountFormat(totalTaxAmount);
    },
    // Keeps the line readable on a big roll without ever implying the list is complete when the
    // backend capped it.
    formatAdditionCodeList(entries, total) {
      const codes = (entries || []).map((entry) => entry.code);
      const shown = codes.slice(0, 20).join(', ');
      const hidden = (total || codes.length) - Math.min(codes.length, 20);
      return hidden > 0 ? `${shown} and ${hidden} more` : shown;
    },
    handleConsolidateView() {
      const editedItem = this.getItemItem;
      const arrOfKeysOwner = ['ownerId'];
      const arrOfKeysOne = ['name1', 'name2'];
      const arrOfKeysTwo = ['inCareOf1', 'inCareOf2'];
      const arrOfKeysThree = ['address1', 'address2', 'address3', 'address4'];
      const arrOfKeysFour = ['city', 'state', 'zip'];

      // get owner id
      const ownerId = arrOfKeysOwner
        .map((ft) => (editedItem[ft] && editedItem[ft].trim()) || '')
        .filter(Boolean);

      // Step 1: Names
      const val1 = arrOfKeysOne
        .map((ft) => (editedItem[ft] && editedItem[ft].trim()) || '')
        .filter(Boolean);

      // Step 2: In-care-of, first one gets C/O
      const val2 = arrOfKeysTwo
        .map((ft) => (editedItem[ft] && editedItem[ft].trim()) || '')
        .filter(Boolean)
        .map((line, index) => (index === 0 ? `C/O ${line}` : line));

      // Step 3: Addresses
      const val3 = arrOfKeysThree
        .map((ft) => (editedItem[ft] && editedItem[ft].trim()) || '')
        .filter(Boolean);

      // Step 4: City + State + ZIP merged
      let val4 = arrOfKeysFour
        .map((ft, i) => (i === 2 ? zipFormat(editedItem[ft]) : (editedItem[ft] && editedItem[ft].trim()) || ''))
        .filter(Boolean);
      val4 = [val4.join(' ')]; // Merge into one line

      const val5 = editedItem.country ? [editedItem.country] : [];

      // Combine all
      const allLines = [...ownerId, ...val1, ...val2, ...val3, ...val4, ...val5];
      return allLines.join('\n');
    },
    formatToPidWithDashes() {
      // if there is no propertyOrParcelId, return empty string
      if (!this.getItemItem.propertyOrParcelId) return '';

      const formatPidPositions = this.taxSettingItem.pidValue || '';
      const formattedPid = pIdFormat(this.getItemItem.propertyOrParcelId, formatPidPositions);
      return formattedPid;
    },
    /* The three rolls behave identically: spin this button, keep all three disabled, and only
       report once the backend says the last write has landed. The backend holds the same
       one-at-a-time lock, so a run started from another tab or by another user comes back as
       ALREADY_RUNNING rather than overwriting this one's work. rollRunning is cleared in a
       finally so a failed roll does not leave a button spinning. */
    async runRoll(roll) {
      if (this.rollInProgress) return;
      this.rollRunning = roll.key;
      try {
        const { statusCode } = await this[roll.action]() || {};
        if (statusCode === 200) {
          this.flashSuccess(roll.success);
          /* Only a 200 marks the button done, and the mark comes from re-reading the server
             rather than from assuming - so a roll whose bookkeeping write did not land shows as
             still to run, which is the safe way round. ALREADY_RUNNING is somebody else's roll
             and 201 is a roll that failed; neither has rolled anything for this file. */
          await this.loadRollStatus();
        } else if (statusCode === ROLL_ALREADY_RUNNING_STATUS) {
          this.flashError(ROLL_ALREADY_RUNNING_MESSAGE);
        } else {
          this.flashError(roll.error);
        }
      } catch (e) {
        this.flashError(roll.error);
      } finally {
        this.rollRunning = null;
      }
    },
    isRollDone(rollKey) {
      return !!(this.rollStatus || {})[rollKey];
    },
    // "Rolled 10/29 2:15 PM by ZachH" - without a username (a roll run headlessly) it just says
    // when, rather than "by null".
    rolledText(rollKey) {
      const run = (this.rollStatus || {})[rollKey];
      if (!run) return '';
      const when = rolledAtText(run.ranAt);
      return `Rolled ${when}${run.ranBy ? ` by ${run.ranBy}` : ''}`;
    },
    async loadRollStatus() {
      const status = await this.loadAssessorRollStatus() || {};
      this.rollStatus = {
        comments: status.comments || null,
        mtgCodes: status.mtgCodes || null,
        statusCodes: status.statusCodes || null,
      };
    },
    /* An import replaces the staged roll, so nothing that was rolled applies to it any more. The
       backend works that out for itself from what is staged - this only brings the buttons back
       straight away rather than at the end of a run that can take minutes. */
    onImportStarted() {
      this.clearAssesorTotal();
      this.rollStatus = { comments: null, mtgCodes: null, statusCodes: null };
    },
    abstractNameRule(value) {
      return !!(value || '').trim() || 'Please name this abstract.';
    },
    /* Back to the default every time rather than keeping the last one: the name describes the
       copy about to be printed, and "Abstract with Duck Creek" belongs to a copy that has
       already been printed and saved. */
    printAbstract() {
      this.abstractName = DEFAULT_ABSTRACT_NAME;
      this.abstractNameDialog = true;
    },
    async confirmPrintAbstract() {
      // Enter on an emptied box must close nothing and print nothing - the OK button is already
      // disabled, and this is the same guard for the keyboard.
      if (!this.abstractNameValid) return;
      const reportName = this.abstractName.trim();
      this.abstractNameDialog = false;
      const { jwt } = await this.reAuth();
      const params = [
        `token=${jwt}`,
        `isItOriginalTaxDistrict=${this.showOriginalTaxDistrictsFlag}`,
        // Free text on its way into a query string - a name with an & in it would otherwise
        // arrive as two parameters and print as half of itself.
        `reportName=${encodeURIComponent(reportName)}`,
      ];
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/newTaxRoll/abstract${queryString}`;
      window.open(url, '_blank');
    },
    async printAdvancedTax() {
      const { jwt } = await this.reAuth();
      const params = [
        `token=${jwt}`,
      ];
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/newTaxRoll/advanceTax${queryString}`;
      window.open(url, '_blank');
    },
    async printErrorsList() {
      const { jwt } = await this.reAuth();
      const params = [
        `token=${jwt}`,
      ];
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/newTaxRoll/errorsList${queryString}`;
      window.open(url, '_blank');
    },
  },
  watch: {
    /* The county's saved Assessor Company arrives with the taxConfig that created() loads, so
       it cannot be read in created() itself. Only ever fills a blank selection: once the
       operator has picked a company on this screen, a late-arriving config must not move it
       under them. An unrecognised saved value is ignored rather than selected, so a typo in
       the setting leaves them choosing for themselves instead of silently offering nothing. */
    'taxSettingItem.assessorCompany': {
      immediate: true,
      handler(savedCompany) {
        if (this.selectedAssessorCompany) return;
        if (!ASSESSOR_COMPANIES.includes(savedCompany)) return;
        this.selectedAssessorCompany = savedCompany;
      },
    },
    /* Same timing as the Assessor Company above: the notes arrive with the taxConfig that
       created() loads, so they cannot be read in created() itself. Once somebody has typed in
       the box the late-arriving config is ignored rather than thrown over their work. */
    'taxSettingItem.newTaxRollNotes': {
      immediate: true,
      handler(savedNotes) {
        if (this.supportNotesTouched) return;
        this.supportNotes = savedNotes || '';
      },
    },
    /* The listing is a live FTP connection, so it is made once, the first time the box
       is actually going to be shown - not in created(), and not again if the operator
       switches companies back and forth. */
    landmarkFtpApplies: {
      immediate: true,
      handler(applies) {
        if (!applies || this.landmarkFtpLoaded) return;
        this.landmarkFtpLoaded = true;
        this.loadLandmarkFtpFiles();
      },
    },
  },
  // watch: {
  //   latestTaxYear(newVal) {
  //     this.newTaxYear = newVal + 1 || null;
  //   },
  // },
};
</script>
